export const APP_BASEURL = window.location.protocol+'//'+window.location.hostname+(window.location.port ? ':'+window.location.port: '')
export const AKENEO_API_URL = process.env.VUE_APP_API_BASE_URL+'akeneo/'
export const SERLI_API_URL = process.env.VUE_APP_API_BASE_URL+'serli/'
export const YOUTUBE_API_URL = process.env.VUE_APP_API_BASE_URL+'youtube/'
export const SPECCHECK_API_URL = process.env.VUE_APP_API_BASE_URL+'speccheck/'
export const AZURE_API_URL = process.env.VUE_APP_API_BASE_URL+'azure_active_directory/'
export const SALESBOX_API_URL = process.env.VUE_APP_API_BASE_URL+'salesbox/'

export const BASE_API_URL = process.env.VUE_APP_API_BASE_URL
//export const MEDIA_URL = process.env.VUE_APP_SERLI_API
export const AD_API_URL = 'https://graph.microsoft.com/v1.0/'
export const AD_CLIENT_ID = 'e03541f2-0c27-4f7c-a9aa-37348c16b8b5'
export const AD_TENANT_ID = '249f5d59-ace3-4c15-a848-6078a21cf60a'
export const AD_NONCE = '62179f10-d31a-4311-adc0-fc5c3b10a963'

export const MEDIA_URL = process.env.VUE_APP_ASSET_URL
export const VIEW_URL = process.env.VUE_APP_VIEW_URL
export const BROCHURE_URL = process.env.VUE_APP_BROCHURE_URL

export const LOGIN_URL = process.env.VUE_APP_LOGIN_URL

export const MAINTENANCE = process.env.VUE_APP_MAINTENANCE
